

(function( ){
//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// この中に処理を書いていってください。

		//-----------------KV Animation START-----------------
		var _header 	= $('.header'),
				_fixedBG  = $('#kv-area .fixed-bg , #ticket-area .fixed-bg'),
				_tickerBG = $('#kv-area .ticker-bg'),
				_kvX      = $('#kv-area .kv-x-area'),
				_catchTxt = $('#kv-area .catch-txt'),
				_logoArea = $('#kv-area .logo-area'),
				_snsArea  = $('#kv-area .sns-area'),
				_inazuma  = $('#kv-area .inazuma-area'),
				_bom      = $('#kv-area .explosion-area'),
				_onpu     = $('#kv-area .onpu-area');



		//初期表示 hedaerは非表示
		_header.css('opacity','0');

		//スライダーティッカーの設定
		$('#ticker-slider').slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 0,
			cssEase: 'linear',
			speed: 5000,
			slidesToShow: 1,
			slidesToScroll: 1,
		});


		//読み込み時のKVの指定
		var loader  = $('.loader , .loader-bg');

		$(window).on('load',function(){
			//一度訪問があったらスプラッシュ画面&KVアニメーションは非表示
			if($.cookie("visit") == "once" ){
				loader.animate({
					left: -10000,
				},2000);
				_kvX.removeClass('zoomin');
					if($('html').hasClass('is__PC width-pc')){
						_pcKV_stop();
					}else if($('html').hasClass('width-sp' || 'is__SP')){
						_spKV_stop();
					}else if($('html').hasClass('is__Tab')){
						_pcKV_stop();
					}
			}else{
				loader.fadeOut().queue(function() {
					$.cookie("visit", "once", { expires: 7 });//初回時Cookie格納
					if($('html').hasClass('is__PC width-pc')){
						_pcKV();
					}else if($('html').hasClass('width-sp' || 'is__SP')){
						_spKV();
					}else if($('html').hasClass('is__Tab')){
						_pcKV();
					}
				});
			}
		});


		//ローディング画面4秒後には強制的に非表示
		setTimeout(function() {
			if($.cookie("visit") == "once" ){
				loader.animate({
					left: -10000,
				},2000);
				_kvX.removeClass('zoomin');
					if($('html').hasClass('is__PC width-pc')){
						_pcKV_stop();
					}else if($('html').hasClass('width-sp' || 'is__SP')){
						_spKV_stop();
					}else if($('html').hasClass('is__Tab')){
						_pcKV_stop();
					}
			}else{
				loader.fadeOut().queue(function() {
					$.cookie("visit", "once", { expires: 7 });//初回時Cookie格納
					if($('html').hasClass('is__PC width-pc')){
						_pcKV();
					}else if($('html').hasClass('width-sp' || 'is__SP')){
						_spKV();
					}else if($('html').hasClass('is__Tab')){
						_pcKV();
					}
				});
			}
		}, 4000);


		//リサイズ時のKVの指定
		$(window).resize(function(){
			if($('html').hasClass('is__PC width-pc')){
				_pcKV_stop();
			}else if($('html').hasClass('width-sp' || 'is__SP')){
				_spKV_stop();
			}
		});

		//KV 「X」の振動を一定時間で呼び出す
		function swingStart(){
			_kvX.addClass('swing');
		}
		function swingEnd(){
			_kvX.removeClass('swing');
		}
		setInterval(swingStart, 8000);
		setInterval(swingEnd, 8300);


		//アニメーションの指定 forPC&Tablet
		function _pcKV(){
			_kvX_animate()
			.then(_catchTxt_animate)
			.then(_logoArea_animate)
			.then(_bg_animate)
			.then(_tickerBG_animate)

			function _kvX_animate(){
				var d = new $.Deferred;
				_kvX.addClass('zoomin').css('opacity','1');
					d.resolve();
				return d.promise();
			}
			function _catchTxt_animate(){
				var d = new $.Deferred;
				_catchTxt.animate({
					left    : 0,
					opacity : 1
				}, 400,'easieEaseInOut', function(){
					d.resolve();
				});
				return d.promise();
			}
			function _logoArea_animate(){
				var d = new $.Deferred;
				_logoArea.animate({
					right   : 0,
					opacity : 1
				}, 350, 'easieEaseInOut',function(){
					_bg_animate()
					_snsArea_animate();
					d.resolve();
				});
				return d.promise();
			}
			function _tickerBG_animate(){
				var d = new $.Deferred;
				_tickerBG.animate({
					opacity: 1,
				}, 300, function(){
					d.resolve();
				});
				return d.promise();
			}

			function _bg_animate(){
				var bg = $('.header , #kv-area .fixed-bg , #ticket-area .fixed-bg , #kv-area .inazuma-area , #kv-area .explosion-area ,#kv-area .onpu-area, #kv-area .copy-right');
				bg.animate({
					opacity : 1
				}, 800);
			}

			function _snsArea_animate(){
				_snsArea.animate({
					opacity : 1
				}, 200);
			}
		}

		function _pcKV_stop(){
			$('.header , #kv-area .fixed-bg , #ticket-area .fixed-bg , #kv-area .ticker-bg , #kv-area .kv-x-area ,  #kv-area .catch-txt , #kv-area .logo-area , #kv-area .sns-area , #kv-area .inazuma-area , #kv-area .explosion-area ,#kv-area .onpu-area, #kv-area .copy-right').css('opacity' ,1);
			_kvX.removeClass('zoomin');
			_catchTxt.css({
				left    : 0
			});
			_logoArea.css({
				right   : 0,
			});
		}

		//アニメーションの指定 forSP
		function _spKV(){
			_kvX_animate()
			.then(_catchTxt_animate)
			.then(_logoArea_animate)
			.then(_bg_animate)
			.then(_tickerBG_animate)

			function _kvX_animate(){
				var d = new $.Deferred;
				_kvX.addClass('zoomin').css('opacity','1');
					d.resolve();
				return d.promise();
			}
			function _catchTxt_animate(){
				var d = new $.Deferred;
				_catchTxt.animate({
					left    : 20,
					opacity : 1
				}, 500,  'easieEaseInOut',function(){
					d.resolve();
				});
				return d.promise();
			}
			function _logoArea_animate(){
				var d = new $.Deferred;
				_logoArea.animate({
					right   : 0,
					opacity : 1
				}, 500,  'easieEaseInOut',function(){
					_bg_animate();
					d.resolve();
				});
				return d.promise();
			}
			function _tickerBG_animate(){
				var d = new $.Deferred;
				_tickerBG.animate({
					opacity: 1,
				}, 300, function(){
					d.resolve();
				});
				return d.promise();
			}
			function _bg_animate(){
				var bg = $('.header , #kv-area .fixed-bg , #ticket-area .fixed-bg , #kv-area .inazuma-area , #kv-area .explosion-area , #kv-area .onpu-area , #kv-area .copy-right');
				bg.animate({
					opacity : 1
				}, 500);
			}
		}
		function _spKV_stop(){
			$('.header , #kv-area .fixed-bg , #ticket-area .fixed-bg , #kv-area .ticker-bg , #kv-area .kv-x-area ,  #kv-area .catch-txt , #kv-area .logo-area , #kv-area .inazuma-area , #kv-area .explosion-area , #kv-area .onpun-area , #kv-area .copy-right').css('opacity' ,1);
			_kvX.removeClass('zoomin');
			_catchTxt.css({
				left    : 20,
			});
			_logoArea.css({
				right   : 0,
			});
		}
		//-----------------KV Animation END-----------------

		//-----------------#cont-area進入時のスクロールアニメーション-----------------
		// target = document.getElementsByClassName("enter-target")[0], target.defClassName = target.className, target.onTarget = function(e) {
		// 	switch (e.type) {
		// 		case "enter":
		// 			e.target.className = e.target.defClassName + " entered";
		// 			break;
		// 		case "exit":
		// 			e.target.className = e.target.defClassName
		// 	}
		// 	$(".news-area").animate({
		// 		opacity: 1
		// 	}, 500);
		// 	$(".twitter-area").animate({
		// 	 right: 0
		//  }, 600);
		// }, ScrollEnterEvent.add(target, {
		// 	onEnter: target.onTarget,
		// 	marginScale: .4,
		// 	autoRemove: !1
		// })

		//-----------------Slider SETTINGS-----------------
		$('#news-slider').slick({
			slidesPerRow: 1,
			autoplay: true,
			autoplaySpeed: 3500,
			prevArrow:    '<a class="slick-prev slider-arrow" href="javascript:void(0)"><img class="slider-icon" src="/park/2018/assets/common/img/parts/icn_left_arrow.gif"></a>',
			nextArrow:    '<a class="slick-next slider-arrow" href="javascript:void(0)"><img class="slider-icon" src="/park/2018/assets/common/img/parts/icn_right_arrow.gif"></a>',
		});

		$('#banner-slider').slick({
			centerMode: true,
			centerPadding: '0px',
			dots: true,
			autoplay: true,
			autoplaySpeed: 3500,
			prevArrow:'<a class="slick-prev slider-arrow" href="javascript:void(0)"><img class="slider-icon" src="/park/2018/assets/common/img/parts/slider_left_arrow.png"></a>',
			nextArrow:'<a class="slick-next slider-arrow" href="javascript:void(0)"><img class="slider-icon" src="/park/2018/assets/common/img/parts/slider_right_arrow.png"></a>',
		});






		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		// {

		// }

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
